module.exports = __webpack_public_path__ + "img/sld_scb_6_t1_green.e7192b07.svg";